<template>
  <!-- 单个添加区域组件 -->
  <div class="page forbit-cancel-tree">
    <Modal
      v-model="dialogVisible"
      class="page-modal"
      width="50%"
      :mask-closable="false"
      :footer-hide="true"
      :title="areaType === 0 ? $t('newarea.add') : $t('newarea.edit')"
      class-name="vertical-center-modal"
    >
      <Spin v-if="spinShow" size="large" fix></Spin>
      <div class="modalContainer modalHeight">
        <Form
          ref="addForm"
          :label-width="150"
          :model="addForm"
          label-colon
          :rules="ruleValidateSingleAddArea"
        >
          <!-- 所属上级区域层级，第一个层级无所属上级区域，不显示 -->
          <FormItem
            v-if="addForm.namePath && addForm.level != 1"
            :label="$t('deviceSip.prevArea')"
            prop="namePath"
            required
          >
            <Input
              v-model="addForm.namePath"
              size="large"
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 5 }"
              clearable
              disabled
            />
          </FormItem>
          <!-- 区域名称 -->
          <FormItem prop="name" :label="$t('area.areaName')">
            <Input
              v-model="addForm.name"
              size="large"
              :maxlength="20"
              :placeholder="$t('area.areaNameHold')"
              clearable
            />
          </FormItem>
          <!-- 区域编号 -->
          <FormItem prop="code" :label="$t('area.areaNum')">
            <Input
              v-model="addForm.code"
              size="large"
              :maxlength="4"
              :placeholder="$t('area.areaNumHold')"
              clearable
            />
          </FormItem>
          <!-- 群呼 -->
          <FormItem prop="groupCall">
            <span slot="label">
              <span class="error-color">*</span>
              {{ $t("updateNewSip.groupCall") }}
            </span>
            <i-switch
              v-model="addForm.groupCall"
              :true-value="1"
              :false-value="0"
              size="large"
              class="margin-right-10"
            />
            <Poptip
              trigger="hover"
              :title="$t('deviceSip.note')"
              placement="right-top"
            >
              <template #content>
                <h4 class="call-tip-box">
                  {{ $t("updateNewSip.groupCallTip") }}
                </h4>
              </template>
              <Icon type="md-help-circle" size="24" color="#FFB22B" />
            </Poptip>
          </FormItem>
        </Form>
      </div>
      <div class="detailBackBtn">
        <Button size="large" @click="closeModal">{{
          $t("common.cancel")
        }}</Button>
        <Button type="primary" size="large" @click="handleSubmit">{{
          $t("common.ensure")
        }}</Button>
      </div>
    </Modal>
    <div class="content_win">
      <!-- 提交确认弹窗 -->
      <modal
        ref="resultModal"
        :type="modalType"
        @afterComfirm="closeModal"
      ></modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAllParentNode, getAllSiblingNode } from "@/utils/tree";

export default {
  name: "ModalBox",
  props: {
    areaType: {
      // 区域modal的操作类型 ：0新增，1编辑
      type: Number,
      default: 0,
    },
    currentNode: {
      // 左侧树选中的节点信息
      type: Object,
      default() {
        // 因为vue规定，对象或数组默认值必须从一个工厂函数获取
        return {};
      },
    },
  },
  data() {
    return {
      spinShow: false,
      dialogVisible: false,
      addForm: {
        name: "",
        code: "",
        namePath: "",
        level: "",
        groupCall: 0,
      }, // 数据表单
      modalType: false,
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "areaData",
      "areaDeviceData",
      "ruleValidateSingleAddArea",
      "allAreaNum",
    ]),
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible === false) {
          this.$refs.addForm.resetFields();
          this.addForm = {
            name: "",
            code: "",
            namePath: "",
            level: "",
            groupCall: 0,
          };
        } else {
          // 编辑赋值显示
          if (this.areaType === 1) {
            this.addForm.name = this.currentNode.name;
            this.addForm.code = String(this.currentNode.code);
            this.addForm.level = this.currentNode.level;
            this.addForm.groupCall = this.currentNode.groupCall
              ? this.currentNode.groupCall
              : 0;
          }
          this.spinShow = false;
          this.setNamePath();
        }
      },
    },
  },
  created() {},
  mounted() {},
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    // 设置namePath显示
    setNamePath() {
      if (!this.currentNode.code) {
        // 无选中的点
        this.addForm.namePath = "";
      } else {
        // 选中当前点，每次打开弹窗都需更新namePath
        // 自己找祖先节点
        let allParentNodeArray = getAllParentNode(
          this.areaDeviceData,
          this.currentNode["$treeNodeId"]
        );

        if (allParentNodeArray.length > 0) {
          // 有祖先节点,倒转，按远到近排
          allParentNodeArray = allParentNodeArray.reverse();
          allParentNodeArray = allParentNodeArray.map((item) => {
            return item.name;
          });
          // 新增弹窗的所属上级区域，需要包含本节点；编辑弹窗的所属上级区域不包含本节点
          if (this.areaType === 0) {
            allParentNodeArray.push(this.currentNode.name);
          }

          this.addForm.namePath = allParentNodeArray.join("-");
        } else {
          this.addForm.namePath = "";
        }
      }
      return this.addForm.namePath;
    },
    closeModal() {
      this.dialogVisible = false;
    },
    // 提交新增、编辑区域
    // 提交方法
    handleSubmit() {
      this.spinShow = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.changeArea();
        } else {
          this.spinShow = false;
        }
      });
    },
    // 更新修改区域，areaType区分
    changeArea() {
      // 区域上限判断
      if (!this.checkAreaNum()) {
        this.spinShow = false;
        return;
      }

      if (this.currentNode.code) {
        // 选中父区域
        this.setDeepArrData(
          this.areaDeviceData,
          this.currentNode["$treeNodeId"],
          "$treeNodeId",
          "groupList",
          "name"
        );
      } else {
        // 选中首层区域，即无当前选中的节点
        let currentObj = {
          name: this.addForm.name,
          code: this.addForm.code,
          codePath: this.addForm.code, // 新增codepath
          children: [],
          groupList: [],
          expand: true,
          level: 1, // 第一层级
          namePath: this.addForm.name, // 首层的区域名称跟名称路径是一样的
          hasSubGroup: 0,
          groupCall: this.addForm.groupCall,
        };

        // 重复code判断
        let isRepeatCode = this.checkAreaRepeat(
          this.areaDeviceData,
          "code",
          this.addForm.code,
          this.addForm.name
        );
        if (!isRepeatCode) {
          this.spinShow = false;
          return;
        }

        this.areaDeviceData.push(currentObj);
        // 区域、设备名称排序  按字符串排序
        this.areaDeviceData = this.areaDeviceData.sort((a, b) => {
          return a.code - b.code;
        });
        // 按区域、设备编号大小排序

        // 添加成功，关闭弹窗
        this.spinShow = false;
        this.$refs.resultModal.dialogVisible = true;
        this.modalType = true;
      }
      this.$store.commit(
        "projectConfig/SET_AREADEVICEDATA",
        this.areaDeviceData
      );
      // 更新树组件的渲染
      this.$emit("updateTree");
    },
    // 递归选中区域节点，然后添加子节点或修改当前节点
    setDeepArrData(
      arr,
      id,
      idStr = "$treeNodeId",
      child = "groupList",
      name = "name"
    ) {
      let that = this;
      for (let i = 0; i < (arr?.length || 0); i++) {
        let item = arr[i];
        if (item[idStr] === id) {
          // 判断是否重复区域编号：新增是当前节点的子区域item.groupList;编辑是当前节点的兄弟区域siblingNode
          let repeatGroupList = [];
          let isRepeatCode = null;
          if (this.areaType === 0) {
            // 新增
            repeatGroupList = item.groupList;
          } else if (this.areaType === 1) {
            // 编辑
            repeatGroupList = getAllSiblingNode(
              this.areaDeviceData,
              this.currentNode["$treeNodeId"]
            );
          }

          // 重复code判断，新增判断
          isRepeatCode = that.checkAreaRepeat(
            repeatGroupList,
            "code",
            this.addForm.code,
            this.addForm.name
          );

          if (!isRepeatCode) {
            this.spinShow = false;
            return;
          }

          // 设置level
          let level = item.level + 1;
          if (this.areaType === 0) {
            // 判断是否为最小层级，不能继续添加子节点
            let commLevel = Number(localStorage.getItem("commLevel"));
            if (commLevel === item.level) {
              this.$Message.error(this.$t("newarea.smallTip"));
              this.spinShow = false;
              return;
            }

            // 新增
            let currentObj = {
              name: this.addForm.name,
              code: this.addForm.code,
              codePath: this.currentNode.codePath + "-" + this.addForm.code, // 新增codepath
              groupCall: this.addForm.groupCall,
              children: [],
              groupList: [],
              level: level,
              expand: true,
              $treeNodeId: Math.floor(Math.random() * 1000000000),
            };
            if (item.hasSubGroup === 0 || !item.hasSubGroup) {
              item.hasSubGroup = 1;
              item.groupList = [];
            }

            if (Array.isArray(item[child])) {
              item.groupList.push(currentObj);

              // 按区域、设备编号大小排序
              item.groupList = item.groupList.sort((a, b) => {
                return a.code - b.code;
              });
            }
          } else if (this.areaType === 1) {
            // 编辑

            // 新增codepath 递归修改codepath
            if (Number(item.code) !== Number(this.addForm.code)) {
              this.setDeepCodePath(
                this.addForm.code,
                item.level,
                item.groupList,
                "groupList"
              );
            }
            item.codePath = this.updateCodePath(
              this.addForm.code,
              item.level,
              item.codePath
            );
            item.name = this.addForm.name;
            item.code = this.addForm.code;
            item.groupCall = this.addForm.groupCall;
            item.changed = 1; // 修改
          }

          // 添加成功，关闭弹窗
          this.spinShow = false;
          this.$refs.resultModal.dialogVisible = true;
          this.modalType = true;
          return;
        }

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepArrData(item[child], id, idStr, child, name);
        }
      }
    },
    /**
     * 递归修改codepath
     * @param updateCode （Array）:更改的code
     * @param level （Number）：区域层级
     * @param arr （Array）:目标数组
     * @param child （String）:目标字段
     */
    setDeepCodePath(updateCode, level, arr, child = "groupList") {
      for (let i = 0; i < (arr?.length || 0); i++) {
        debugger;
        let item = arr[i];
        item.codePath = this.updateCodePath(updateCode, level, item.codePath);

        if (Array.isArray(item[child]) && item[child].length > 0) {
          this.setDeepCodePath(updateCode, level, item[child], child);
        }
      }
    },
    // 更新codepath
    updateCodePath(updateCode, level, beforeCodePath) {
      let codePath = "";
      let codePathArray = beforeCodePath.split("-");
      codePathArray[level - 1] = updateCode;
      codePath = codePathArray.join("-");

      return codePath;
    },

    /**
     * 判断同个层级的区域编号、名称是否重复
     * @param array （Array）:目标数组
     * @param key （String）：键值
     * @param code （String）:目标编号
     * @return returnBoolean ：重复判断，false为重复
     */
    checkAreaRepeat(array, key, code, name) {
      let returnBoolean = true;
      let arrayCodeList = array.map((item) => {
        return Number(item[key]);
      });
      let arrayNameList = array.map((item) => {
        return item.name;
      });

      // 判断是否重复code
      // 编辑时格外判断，如不修改情况
      if (
        this.addForm.level === this.currentNode.level &&
        name === String(this.currentNode.name) &&
        code === String(this.currentNode.code)
      ) {
        return returnBoolean;
      } else if (
        this.addForm.level === this.currentNode.level &&
        name !== String(this.currentNode.name) &&
        code === String(this.currentNode.code)
      ) {
        if (arrayNameList.includes(name)) {
          returnBoolean = false;
          this.$Message.error(this.$t("updateNewSip.nameRepeatTip"));
          return returnBoolean;
        }
      } else if (
        this.addForm.level === this.currentNode.level &&
        name === String(this.currentNode.name) &&
        code !== String(this.currentNode.code)
      ) {
        if (arrayCodeList.includes(Number(code))) {
          returnBoolean = false;
          this.$Message.error(this.$t("updateNewSip.codeRepeatTip"));
          return returnBoolean;
        }
      } else {
        if (arrayNameList.includes(name)) {
          returnBoolean = false;
          this.$Message.error(this.$t("updateNewSip.nameRepeatTip"));
          return returnBoolean;
        }
        if (arrayCodeList.includes(Number(code))) {
          returnBoolean = false;
          this.$Message.error(this.$t("updateNewSip.codeRepeatTip"));
          return returnBoolean;
        }
      }

      return returnBoolean;
    },
    // 区域所有节点10000个的限制
    checkAreaNum(maxNum = 10000) {
      let isNext = true;
      // 判断区域是否超出上限
      if (this.allAreaNum + 1 > maxNum) {
        this.$Message.error(this.$t("updateNewSip.areaMax"));
        isNext = false;
      }
      return isNext;
    },
  },
};
</script>
